import { fetchBasicJsonPost, fetchBasicJsonPostJson, fetchBasicUrlGetJson } from '@/script/common';

export default {
    getWard: id =>
        fetchBasicUrlGetJson('/Ward/Get', { data: { id } }),
    getWards: (departmentCode, isMyPatient, patientName) =>
        fetchBasicJsonPostJson('/Ward/GetWards', {
            data: {
                departmentCode: departmentCode || null,
                isMyPatient: isMyPatient || false,
                patientName: patientName || null,
            }
        }),
    getCurrentHistoriesWithoutWard: filter =>
        fetchBasicJsonPostJson('/Ward/CurrentHistoriesWithoutWard', { data: filter }),
    getHistoriesWithLeaveWithoutClose: filter =>
        fetchBasicJsonPostJson('/Ward/HistoriesWithLeaveWithoutClose', { data: filter }),
    addToWard: (historyCode, wardId) =>
        fetchBasicJsonPost('/DiagnosisDepartment/AddToWard', { data: { historyCode, wardId } }),
    setCurrentWard: (historyCode, wardId) =>
        fetchBasicJsonPost('/DiagnosisDepartment/SetCurrentWard', { data: { historyCode, wardId } }),
    changeWard: (historyCode, fromWardId, toWardId) =>
        fetchBasicJsonPost('/DiagnosisDepartment/ChangeWard', { data: { historyCode, fromWardId, toWardId } }),
    leaveWard: ({ historyCode, datetime, wardId, toDepartmentCode, toWardId }) =>
        fetchBasicJsonPost('/DiagnosisDepartment/LeaveWard', { data: { historyCode, datetime, wardId, toDepartmentCode, toWardId } }),
    endHistory: (historyCode, datetime) =>
        fetchBasicJsonPost('/DiagnosisDepartment/EndHistory', { data: { historyCode, datetime } }),
    deleteLaying: (historyCode, wardId) =>
        fetchBasicJsonPost('/DiagnosisDepartment/DeleteLaying', { data: { historyCode, wardId } }),
};
